<template>
  <footer class="sideNav" style="z-index: 1000">
    <general-warning :warning="warning" />
    <div class="row around-xs bottombar" id="navItems">
      <router-link to="/monitoring">
        <div>
          <eye-icon title="" />
          <span>Monitorar</span>
        </div>
      </router-link>
      <router-link to="/registers">
        <div>
          <pencil-icon title="" />
          <span>Registrar</span>
        </div>
      </router-link>
    </div>
  </footer>
</template>

<script>

export default {
  name: "sideNav",
  props: {
    warning: [String],
    notifs: Array,
    alertsAccess: Boolean,
    notifServerStatus: [Number],
  },
  data() {
    return {
      alerts: 0,
      qaMonit: 0,
      qaRegist: 0,
    };
  },
};
</script>


<style scoped>
.bottombar {
  display: flex;
  align-items: center;
  background-color: #3d9161;
  background-color: #ffff;
}

.bottombar {
  border-top: none;
  width: 100%;
}

.router-link-active,
.router-link-active span {
  background-color: #378459;
  padding: 0;
  color: #f1f1f1;
}

.sideNav .bottombar a .bell {
  padding: 0;
  margin: 0;
}

.sideNav .bottombar a .bell .err-notif-server {
  color: #c92d39;
}

@media screen and (max-width: 425px) {
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
  }

  a .material-design-icon {
    font-size: 1.3rem !important;
    padding: 0 !important;
  }
}

@media screen and (max-width: 280px) {
  div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

a {
  flex-grow: 1;
  padding: auto;
  margin: 0;
  height: 100%;
}

a div {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color: #f1f1f1;
  padding: 0;
  text-decoration: none;
  text-align: center;
  width: 50px;
  margin: 0 auto;
  line-height: 0.8em;
}

a div span {
  font-size: 0.64em;
  padding: 0;
  margin-top: 1px;
}

a div .material-design-icon {
  font-size: 1.10rem !important;
  padding: 0 !important;
  align-self: center;
  height: 0.9em;
  margin: 0;
}
</style>
